import '../styles/categories.css';
import TiltCard from './TiltCard';

const CategoriesSection = () => {
  const cats = [
    { emoji: "🚗", name: "Cars", count: "8,200+" },
    { emoji: "🏍️", name: "Motorcycles", count: "4,500+" },
        { emoji: "🚙", name: "SUVs", count: "3,400+" },

    { emoji: "🚚", name: "Trucks", count: "1,800+" },
    { emoji: "🚐", name: "Vans & Buses", count: "1,200+" },
    { emoji: "🚜", name: "Pickup Trucks", count: "2,100+" },
    { emoji: "🚗", name: "Sedans", count: "2,800+" },
    { emoji: "🚘", name: "Hatchbacks", count: "1,600+" },
  ];

  return (
    <section className="categories" id="categories">
      <div className="container">
        <span className="section-tag animate-on-scroll">🚗 Vehicle Categories</span>
        <h2 className="section-title animate-on-scroll">Every Wheel Under One Roof</h2>
        <p className="section-desc animate-on-scroll">From daily commuter motorcycles to commercial trucks: all vehicle types across Zambia, in one app.</p>
        <div className="cat-grid stagger-children">
          {cats.map((c) => (
            <TiltCard className="cat-card animate-on-scroll" key={c.name}>
              <div className="cat-emoji">{c.emoji}</div>
              <h3>{c.name}</h3>
              <span className="cat-count">{c.count} listings</span>
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
